import { Route, Routes } from "react-router";
import AdminPage from "../../AdminPage/AdminPage.js";
import AlertsPage from "../../AlertsPage/AlertsPage.js";
import AnalyticsPage from "../../AnalyticsPage/AnalyticsPage.js";
import MapPage from "../../MapPage/MapPage.js";
import ChannelPage from "../../ChannelPage/ChannelPage.js";
import DashboardPage from "../../DashboardPage/DashboardPage.js";
import EditPage from "../../EditPage/EditPage.js";
import NewChannelPage from "../../NewChannelPage/NewChannelPage.js";
import StationsPage from "../../StationsPage/StationsPage.js";
import DevStationsPage from "../../StationsPage/DevStationsPage.js";
import ProfilePage from "../../ProfilePage/ProfilePage.js";
import SettingsPage from "../../SettingsPage/SettingsPage.js";
import ProtectedRoute from "./ProtectedRoute.js";
import DebugPage from "../../DebugPage/DebugPage.js";

export default function RoutingComponent() {
    return (
        <Routes>
            <Route element={<ProtectedRoute />}>
                <Route path="/stationspage" element={<StationsPage />} />
                <Route path="/devpage" element={<DevStationsPage />} />
                <Route path="/channelpage/:channelID" element={<ChannelPage />} />
                <Route path="/newchannelpage/:channelID" element={<NewChannelPage />} />
                <Route path="/editpage/:channelID" element={<EditPage />} />
                <Route path="/adminpage" element={<AdminPage />} />
                <Route path="/alertspage" element={<AlertsPage />} />
                <Route path="/analyticspage" element={<AnalyticsPage />} />
                <Route path="/mappage" element={<MapPage />} />
                <Route path="/profilepage" element={<ProfilePage />} />
                <Route path="/settingspage" element={<SettingsPage />} />
                <Route path="/debugpage" element={<DebugPage />} />
                <Route path="/" element={<DashboardPage />} />
            </Route>
        </Routes>
    );
}
